/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { Container, Row } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header pb-5 pt-5 pt-md-8" style={{'backgroundColor': 'white'}}>
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
